import asyncSeries from 'async/series';

import MediaGrantStore from './media_grant_store';
import UserStore from './user_store';
import VolumeStore from './volume_store';

export default {
  init,
};
function init(done: any) {
  asyncSeries([UserStore.init, VolumeStore.init, MediaGrantStore.init], done);
}
